import { useWatch } from "react-hook-form";
import React, { useEffect, useState } from "react";
import * as notify from "../../../../shared/notify";
import { TaskReasonFormFields } from "./task-reason-form-fields";
import { UpcReasonFormFields } from "./upc-reason-form-fields";

export const TaskRow = ({
    control,
    allowedTaskOptions,
    index,
    selectedUpcs,
    allRejectReasonOptions,
    selectedTasks,
    error = {},
    onValidateSelection,
    onRemoveTask,
}) => {
    const [multiRejectReason, setMultiRejectReason] = useState(false);
    const [rejectReasonOptions, setRejectReasonOptions] = useState([]);
    const selectedTask = useWatch({
        control,
        name: `rejectTasks[${index}].task`,
    });

    useEffect(() => {
        if (selectedTask && allRejectReasonOptions) {
            const options = allRejectReasonOptions[selectedTask];
            setRejectReasonOptions([
                ...options.map((option) => {
                    return {
                        text: option.rejectReason,
                        value: option.rejectReason,
                    };
                }),
                {
                    text: "Other",
                    value: 0,
                },
            ]);
        }
    }, [allRejectReasonOptions, selectedTask]);

    const handleConfirmSwitchMode = async () => {
        if (!multiRejectReason) {
            setMultiRejectReason(true);

            return;
        }

        const confirm = await notify.confirm("Are you sure you want to specify one reason for all UPC(s)?");

        if (confirm) {
            setMultiRejectReason(false);
        }
    };

    return (
        <>
            <TaskReasonFormFields
                index={index}
                control={control}
                error={error}
                multiRejectReason={multiRejectReason}
                selectedTask={selectedTask}
                allowedTaskOptions={allowedTaskOptions}
                rejectReasonOptions={rejectReasonOptions}
                selectedTasks={selectedTasks}
                onValidateSelection={onValidateSelection}
            />
            {multiRejectReason &&
                selectedUpcs.map(({ key, context }, upcIndex) => {
                    return (
                        <UpcReasonFormFields
                            key={context.key}
                            index={index}
                            upcIndex={upcIndex}
                            upc={context.upc}
                            contextKey={context.key}
                            productModifier={context.productModifier}
                            control={control}
                            selectedTask={selectedTask}
                            error={error}
                            rejectReasonOptions={rejectReasonOptions}
                        />
                    );
                })}
            <div className={`m-b-10 flex justify-content-${index > 0 ? "between" : "end"}`}>
                {index > 0 && (
                    <button
                        className="button -text"
                        onClick={() => onRemoveTask(index)}
                    >
                        Remove Reject Task
                    </button>
                )}
                <button
                    type="button"
                    className="button -text"
                    onClick={handleConfirmSwitchMode}
                >
                    {multiRejectReason ? "Specify one reason for all UPC(s)" : "Specify different reason per selected UPC"}
                </button>
            </div>
        </>
    );
};
